// extracted by mini-css-extract-plugin
module.exports = {"root":"ButtonGroup-m__root___ZdbAm","item":"ButtonGroup-m__item___Rt0xi","centered":"ButtonGroup-m__centered___bW+rV"};